// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconPeopleTeam = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M10.22 11.674C9.072 11.899 7.957 12.34 7 13H6c-1.429 0-3 .5-4 1.5V20h20v-5.5c-1-1-2.571-1.5-4-1.5h-.99a8.3 8.3 0 00-3.214-1.332A9.6 9.6 0 0012 11.5c-.59 0-1.19.058-1.78.174M8 18v-3.257c1.086-.796 2.545-1.243 4-1.243 1.505 0 2.911.424 4 1.238V18zm2.504-8.399c.44.254.951.399 1.496.399a3 3 0 003-3 3 3 0 10-4.496 2.601M12 6a1 1 0 100 2 1 1 0 000-2"
    />,
    <path d="M6 8a2 2 0 100 4 2 2 0 000-4m10 2a2 2 0 114 0 2 2 0 01-4 0" />
  );
export default SvgIconPeopleTeam;
